/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect, useState } from "react";
import { Slide } from "react-slideshow-image";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-slideshow-image/dist/styles.css";
import { errorToast, getErrorObject } from "utilities/utils";
import { getBanners } from "services/banners";
import OfferBannerImg from "../../assets/images/banner-home-callus.svg";
import { Fade, Zoom } from "react-reveal";
import { Link } from 'react-router-dom';
import "./DashboardSlider.css";
import { DOMAIN_NAME } from "constants/common";
export default function DashBoardSlider() {
  const [sliderImages, setSliderImages] = React.useState([]);
  const [windowWidth, setWindowWidth] = useState(0);

  let resizeWindow = () => {
    setWindowWidth(window.screen.width);
  };

  useEffect(() => {
    _getAllBanners();
  }, []);
  const _getAllBanners = async () => {
    try {
      let response = await getBanners({
        domain: DOMAIN_NAME,
      });
      // console.log(
      //   "🚀 ~ file: DashBoardSlider.jsx:28 ~ _getAllBanners=async ~ response:",
      //   response
      // );
      const sliderImages = response?.data?.data?.docs;
      sliderImages.forEach((sliderImage) => {
        if(sliderImage._id == "67363478aa80c1a7b4bd5045"){
          sliderImage.link = "/hajj-package";
        } else if(sliderImage._id == "66910b01222976a10cdf1461"){
          sliderImage.link = "/packages/Umrah/standard-4-days-package";
        } else if(sliderImage._id == "66910af1222976a10cdf144c"){
          sliderImage.link = "/packages/Umrah/economy-4-days-package";
        } else if(sliderImage._id == "66910ad5222976a10cdf1440"){
          sliderImage.link = "/packages/Umrah/premium-4-days-package";
        } else if(sliderImage._id == "66910abc222976a10cdf143a"){
          sliderImage.link = "/packages/Umrah/luxury-4-days-package";
        } else {
          sliderImage.link = "/";
        }
      });

      setSliderImages(sliderImages);
    } catch (e) {
      const { message } = getErrorObject(e);
      errorToast({
        content: message,
      });
    }
  };

  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);
  return (
    <div className="slide-container">
      {sliderImages?.length > 0 && (
        <Carousel
          showThumbs={false}
          useKeyboardArrows={true}
          autoPlay={true}
          infiniteLoop={true}
          showStatus={false}
          showIndicators={true}
          interval="6000"
        >
          {sliderImages.map((slideImage, index) => (

            <Link to={slideImage.link} style={{display: "block"}}>
            <img
              key={index}
              src={
                windowWidth > 768 ? slideImage.image : slideImage?.mobile_image
              }
              alt={
                windowWidth > 768 ? slideImage.image : slideImage.mobile_image
              }
              width="auto"
              height="auto"
            />
            </Link>
          ))}
        </Carousel>
      )}
    </div>
  );
}
